import type { PageProps } from 'gatsby';
import React from 'react';
import { useSearchParam } from 'react-use';

import AppLayout from '@layouts/AppLayout';

import DicomViewer from '@views/Records/ImagingTests/DicomViewer';

export default function ImagingTestsPage({ params }: PageProps) {
  // Diagnostic report ID
  const reportId = params.id;
  // Imaging study ID
  const studyId = useSearchParam('id');

  return (
    <AppLayout>
      <DicomViewer reportId={reportId} studyId={studyId ?? undefined} />;
    </AppLayout>
  );
}
